import { createContext } from 'react';
import { type DeviceType } from '../types/DeviceType';

export const DeviceTypeContext = createContext<DeviceType>('desktop');
